module.exports = __webpack_public_path__ + "img/sense4future-logo-draft.4f151008.svg";